import {CONTENT_CHAPTERS} from "../actions/actionTypes";

const loaded_chapters = (state = [], action) => {
    switch (action.type) {
        case CONTENT_CHAPTERS:
            return action.allElements;
        default:
            return state;
    }
};

export default loaded_chapters;



// WEBPACK FOOTER //
// ./src/reducers/loaded_chapters.js